import React from 'react';
import PropTypes from 'prop-types';
import TextArea from 'react-expanding-textarea';

import './note_form.scss';

const NoteFormSimple = ({ onBlur, onChange, note, placeholder }) => (
  <div className="note-form">
    <TextArea
      className="form-control"
      id="note_form"
      onBlur={onBlur}
      onChange={onChange}
      placeholder={placeholder}
      value={note}
    />
  </div>
);

NoteFormSimple.propTypes = {
  note: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
};

NoteFormSimple.defaultProps = {
  placeholder: 'Enter note...',
};

export default NoteFormSimple;
